import { render, staticRenderFns } from "./footer-section.vue?vue&type=template&id=1a48851f&scoped=true&"
import script from "./footer-section.vue?vue&type=script&lang=js&"
export * from "./footer-section.vue?vue&type=script&lang=js&"
import style0 from "./footer-section.vue?vue&type=style&index=0&id=1a48851f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a48851f",
  null
  
)

export default component.exports